import React from "react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
const ApplicationInsightsContext = React.createContext<ApplicationInsights | null>(null);

export default ApplicationInsightsContext;
